export const SB_CACHE_VERSION_TAG = "cms";